import { ReactNode } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { useAmIDsl } from "@/hooks/useDsl";
import { RequireRole } from "@/components/RequireRole";

/**
 * Guards the confidential safeguarding section. Owners and Admins reach it through
 * their role, and the named Designated Safeguarding Lead reaches it whatever their
 * usual role is. It opens nothing else.
 */
export function RequireSafeguardingAccess({ children }: { children: ReactNode }) {
  const { role } = useAuth();
  const { isDsl, isLoading } = useAmIDsl();

  if (role === "super_admin" || role === "admin") return <>{children}</>;
  if (isLoading) return null;
  if (isDsl) return <>{children}</>;

  return <RequireRole allowed={["super_admin", "admin"]}>{children}</RequireRole>;
}
